import { Button, Stack, Typography } from "@mui/material";
import { AttachFile } from "@mui/icons-material";

import _ from "lodash";

import SectionPreview from "../../../common/components/SectionPreview";
import { apiFileDownloadEndpoint } from "../../../common/components/mui-extended/DropzoneExtended";
import {
  AuthorizationForWithdrawal,
  WithdrawnAuthorizationPreviewDto,
} from "../../../interfaces/WithdrawnAuthorization";
import { dateToStringShort, dateToStringLongSuffix } from "../../../common/utils/dateTime";
import { formatNotaryData } from "../../../common/utils/formatters";

type WithdrawnAuthorizationProps = {
  model?: WithdrawnAuthorizationPreviewDto;
};

const WithdrawnAuthorization = ({ model }: WithdrawnAuthorizationProps) => {
  const renderAuthorizationIssuer = (authorization: AuthorizationForWithdrawal) => {
    return formatNotaryData(authorization.notary?.name, authorization.notary?.number);
  };

  const renderWithdrawnAutorizationData = () => (
    <>
      <Typography>
        Документ за оттегляне на пълномощно{" "}
        <strong>{`${model?.registrationNumber} / ${dateToStringShort(model?.issueDate)}`}</strong>
      </Typography>
      <Typography>
        издадено от нотариус <strong>{model?.notary?.name}</strong>, номер{" "}
        <strong>{_.padStart(model?.notary?.number?.toString(), 3, "0")}</strong>, район на действие{" "}
        <strong>{model?.notary?.settlementName}</strong>.
      </Typography>
    </>
  );

  return (
    <Stack spacing={3}>
      <Typography variant="subtitle2">
        Дата на въвеждане в регистъра: {dateToStringLongSuffix(model?.createDate)}
      </Typography>
      <SectionPreview title="Данни за документ">{renderWithdrawnAutorizationData()}</SectionPreview>
      <SectionPreview title="Оттеглени пълномощни">
        {model?.authorizations?.map((item) => (
          <Typography key={item.registrationNumber}>
            <strong>{`${item.registrationNumber} / ${dateToStringShort(item.issueDate)}`}</strong>, издадено от
            {item.notary?.id !== undefined ? ` нотариус ` : ` населено място `}
            <strong>{renderAuthorizationIssuer(item)}</strong>
          </Typography>
        ))}
      </SectionPreview>
      <SectionPreview title="Упълномощител/и">{model?.authorizer}</SectionPreview>
      <SectionPreview title="Упълномощен/и">{model?.authorized}</SectionPreview>
      <SectionPreview title="Данни за документа, с който се оттегля пълномощното">{model?.description}</SectionPreview>
      {model?.file?.blobId && (
        <SectionPreview title="Сканирано копие">
          <Button
            startIcon={<AttachFile />}
            variant="outlined"
            href={`${apiFileDownloadEndpoint}/${model?.file?.blobId}`}
          >
            {model?.file?.name}
          </Button>
        </SectionPreview>
      )}
    </Stack>
  );
};

export default WithdrawnAuthorization;
